import React from 'react'
import { FaTimes } from 'react-icons/fa'

import './ListItem.css'

function ListItemTable({ step, itemName, onDelete }) {
  return (
    <div className="ListItemTable">
      <div className="step">{step}-</div>
      <div className="tp">{itemName}</div>
      {onDelete ? (
        <div className="delete" onClick={onDelete}>
          <FaTimes size={12} color="red" />
        </div>
      ) : null}
    </div>
  )
}
export default function ListTable({ items, onDelete }) {
  const sortedItems = [...items].sort((a, b) => a.step - b.step)
  return (
    <div>
      {sortedItems.map(i => (
        <ListItemTable
          onDelete={onDelete ? () => onDelete(i) : undefined}
          key={i.step_id != null ? i.step_id : i.itemName}
          step={i.step}
          itemName={i.itemName}
        />
      ))}
    </div>
  )
}
